<micro-select-combo #sel
              placeholder="Database Connection"
              routerBase="sqls"
              [mode]="mode"
              [(id)]="sqlServerId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
